import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Section from '../components/common/Section';
import Button, { PrimaryButton } from '../components/common/Button';

const NotFoundContainer = styled.div`
  text-align: center;
  padding: 5rem 0;
`;

const NotFoundTitle = styled.h1`
  font-size: 6rem;
  margin-bottom: 1rem;
  color: ${props => props.theme.colors.primary};
`;

const NotFoundText = styled.p`
  font-size: 1.5rem;
  margin-bottom: 2rem;
`;

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <Section>
      <NotFoundContainer>
        <NotFoundTitle>404</NotFoundTitle>
        <NotFoundText>Page Not Found</NotFoundText>
        <Button to="/" variant="secondary" size="large">{t('Back to Home', { defaultValue: 'Back to Home' })}</Button>
      </NotFoundContainer>
    </Section>
  );
};

export default NotFound;